export default __webpack_public_path__ + "static/media/music3.06857a9f.jpg";